import { campoDeveSerMaiorQueZero, campoObrigatorio } from 'helpers/Constantes/Mensagens'

export type DadosInfraestrutura = {
  viarioInternoCondominio: string
  valido: boolean
}

export const dadosInfraestruturaValorDefault = {
  viarioInternoCondominio: ''
} as DadosInfraestrutura

export class ValidacaoDadosInfraestrutura {
  viarioInternoCondominio: string

  constructor(viarioInternoCondominio = '') {
    this.viarioInternoCondominio = viarioInternoCondominio
  }

  validarViarioInternoCondominio(viarioInternoCondominio: string): string {
    let error = ''

    if (parseFloat(viarioInternoCondominio) === 0) error = campoDeveSerMaiorQueZero

    if (viarioInternoCondominio === '') error = campoObrigatorio

    return error
  }
  validarTodosCampos(state: DadosInfraestrutura): boolean {
    return state.viarioInternoCondominio != '' && this.viarioInternoCondominio === ''
  }
}
